export const GET_FAVORITES = 'GET_FAVORITES';
export const GET_FAVORITES_SUCCESS = 'GET_FAVORITES_SUCCESS';
export const GET_FAVORITES_FAILURE = 'GET_FAVORITES_FAILURE';
export const DELETE_FAVORITE_SNAP = 'DELETE_FAVORITE_SNAP';
export const DELETE_FAVORITE_SUCCESS = 'DELETE_FAVORITE_SUCCESS';
export const ADD_FAVORITE_SNAP = 'ADD_FAVORITE_SNAP';
export const LOAD_MORE_FAVORITES_SUCCESS = 'LOAD_MORE_FAVORITES_SUCCESS';
export const LOAD_MORE_FAVORITES = 'LOAD_MORE_FAVORITES';
